const app = angular.module('msi.shipping.modal', [
  'ui.router',
  'ui.bootstrap',
  require('@ordergroove/brandy/src/app/addresses'),
  require('@ordergroove/brandy/src/app/shipments/shipments.service')
]);

app.service('editShippingModal', require('./edit-shipping-modal'));
app.config(require('./states'));

module.exports = app.name;
